import { Children, cloneElement, useState } from "react";
import { Button as BSButton, Col, Row } from "react-bootstrap";
import { Button as ButtonProduct } from "../fields";
const AddonAlert = ({
  text,
  handleButton,
  button_text,
  display,
  children,
  show_button = false,
  buttonProps,
  ...props
}) => {
  const [selected, setSelected] = useState(false);

  if (!display)
    return (
      <Row className="mb-3">
        <Col sm={6}>{children}</Col>
      </Row>
    );
  const handleAdd = () => {
    handleButton();
    setSelected(true);
  };
  const child_props = {};
  if (!selected) child_props.label = false;
  const childrenWithProps = Children.map(children, (child) =>
    cloneElement(child, child_props)
  );

  const Button = !!buttonProps ? ButtonProduct : BSButton;
  return (
    <div {...props} className={`addon-alert p-3 ${props.className || "mb-5"}`}>
      {text}
      <Row className="align-items-center">
        {(show_button || !selected) && (
          <>
            <Col xs={12} sm={true}>
              <Button block onClick={handleAdd} {...buttonProps}>
                {button_text}
              </Button>
            </Col>
            {childrenWithProps?.length > 0 && (
              <Col xs={12} sm="auto" className="mx-1 text-center">
                or
              </Col>
            )}
          </>
        )}
        {childrenWithProps?.length > 0 && (
          <Col xs={12} sm={true}>
            {childrenWithProps}
          </Col>
        )}
      </Row>
    </div>
  );
};

export default AddonAlert;
